import { useSelector } from 'react-redux';
import { Chip, Text, Spacer, Cell } from '@vinted/web-ui';
import SeparatedList from 'components/SeparatedList';
import useTranslate from 'hooks/useTranslate';
import useTracking from 'hooks/useTracking/useTracking';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { clickEvent } from 'libs/common/event-tracker/events';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { Screen } from 'constants/tracking/screens';
import { FeedbackFilterType } from '../../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const FeedbackFilters = _ref => {
  let {
    selectedFeedbackFilterType,
    showFilters,
    onClick
  } = _ref;
  const translate = useTranslate('user.feedback.filters');
  const {
    track
  } = useTracking();
  const isTransparentFeedbackEnabled = useSelector(getIsFeatureSwitchEnabled('web_transparent_autofeedback'));

  const getCurrentTargetElement = feedbackFilterType => {
    switch (feedbackFilterType) {
      case FeedbackFilterType.Auto:
        return ClickableElement.FeedbackAutoReviewsFilter;

      case FeedbackFilterType.Members:
        return ClickableElement.FeedbackMemberReviewsFilter;

      default:
        return ClickableElement.FeedbackAllReviewsFilter;
    }
  };

  const handleClick = feedbackFilterType => () => {
    track(clickEvent({
      target: getCurrentTargetElement(feedbackFilterType),
      screen: Screen.UserProfile
    }));
    onClick(feedbackFilterType);
  };

  if (!isTransparentFeedbackEnabled || !showFilters) return null;
  return /*#__PURE__*/_jsx(Cell, {
    children: /*#__PURE__*/_jsx("div", {
      className: "u-flexbox",
      children: /*#__PURE__*/_jsxs(SeparatedList, {
        separator: /*#__PURE__*/_jsx(Spacer, {
          orientation: Spacer.Orientation.Vertical
        }),
        children: [/*#__PURE__*/_jsx(Chip, {
          activated: selectedFeedbackFilterType === FeedbackFilterType.All,
          text: translate('all'),
          textType: Text.Type.Subtitle,
          onClick: handleClick(FeedbackFilterType.All)
        }), /*#__PURE__*/_jsx(Chip, {
          activated: selectedFeedbackFilterType === FeedbackFilterType.Members,
          text: translate('members'),
          textType: Text.Type.Subtitle,
          onClick: handleClick(FeedbackFilterType.Members)
        }), /*#__PURE__*/_jsx(Chip, {
          activated: selectedFeedbackFilterType === FeedbackFilterType.Auto,
          text: translate('auto'),
          textType: Text.Type.Subtitle,
          onClick: handleClick(FeedbackFilterType.Auto)
        })]
      })
    })
  });
};

export default FeedbackFilters;